import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Copyright from "../../components/Footer/Copyright";
import api from "../../services/api";
import {parseResponse, useQuery} from "../../services/helpers";
import {useSnackbar} from "notistack";
import Link from "@material-ui/core/Link";
import {Link as RouterLink} from "react-router-dom";
import {TextField} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function ResetPassword(props) {
    let query = useQuery();
    const classes = useStyles();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [token] = useState(query.get("token"));
    const { enqueueSnackbar } = useSnackbar();

    function handleSubmit(e) {
        e.preventDefault();
        api.post('/password/reset', {
            token: token,
            email: email,
            password: password,
            password_confirmation: passwordConfirmation
        }).then(response => {
            console.log(response);
            if (response.status >= 200 && response.status < 300) {
                props.handleLogin(response.data && response.data.data && response.data.data.user ? response.data.data.user : null);
                enqueueSnackbar(parseResponse(response), {
                    variant: 'success',
                });
            }
        }).catch(error => {
            console.log(error);
            if (error.response && error.response.status === 422) {
                enqueueSnackbar(parseResponse(error), {
                    variant: 'warning',
                });
            } else {
                enqueueSnackbar('An internal error has occurred.', {variant: 'error'});
            }
        });
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Reset Password
                </Typography>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            Please confirm your email and create a new password.
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                type="email"
                                id="email"
                                label="Confirm Your Email"
                                name="email"
                                autoComplete="email"
                                onChange={e => setEmail(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                type="password"
                                id="password"
                                label="Password"
                                name="password"
                                autoComplete="password"
                                onChange={e => setPassword(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                type="password"
                                id="password_confirmation"
                                label="Confirm Password"
                                name="password_confirmation"
                                autoComplete="password_confirmation"
                                onChange={e => setPasswordConfirmation(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={handleSubmit}
                    >
                        Change Password
                    </Button>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Link component={RouterLink} to="/login" variant="body2">
                                Sign in with new password
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Box mt={5}>
                <Copyright />
            </Box>
        </Container>
    );
}